<template>
    <li v-if="filterData[dataKey].length > 0" class="filter-category" v-click-outside="closeWindow">
        <div class="filter-category-title" @click="toggleViewOptions" :class="{ 'filter-category-title-open': showFilters }">
            <div class="filter-category-title-name-wrapper">
                <div class="filter-category-title-name">{{ title }}</div>
                <div class="filter-category-title-selected">
                    {{ __('frontend_js.category.selected') }} ({{ filters[dataKey].length }})
                </div>
            </div>

            <div v-if="showFilters" class="filter-category-options" ref="optionsEl" @click.stop="">
                <div class="filter-category-options-wrapper">
                    <div class="filter-category-options-flex">
                        <product-filter-item
                            v-for="item in filterData[dataKey]"
                            :key="item.id"
                            v-model="form[item.id]"
                            :item="item"
                            :data-key="dataKey"
                            :is-current-filter-active="isCurrentFilterActive"
                            :hide-counter="hideCounter"
                        />
                    </div>
                    <div class="filter-category-option-close close-icon" @click.stop="showFilters = false"></div>
                </div>

                <div class="filter-category-option-button">
                    <button class="text-uppercase shop-button" @click.stop="filter">
                        {{ __('frontend_js.category.select') }}
                    </button>
                </div>

                <loader v-if="loading" />
            </div>
        </div>
    </li>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    props: {
        title: { required: true },
        dataKey: { required: true },
    },

    data() {
        return {
            form: {},
            showFilters: false,
        };
    },

    computed: {
        ...mapGetters('product-filters', ['filterData', 'filters', 'hideCounter']),
        ...mapGetters('product-list', ['loading']),
        isCurrentFilterActive() {
            return this.filters[this.dataKey].length > 0;
        },
    },

    created() {
        this.setChecked();

        this.$root.$on('close-filter-options', () => {
            if (this.showFilters == true) {
                this.filter();
                this.showFilters = false;
            }
        });
    },

    watch: {
        filters: {
            deep: true,
            handler: function () {
                this.setChecked();
            },
        },
    },

    methods: {
        toggleViewOptions() {
            if (this.showFilters) {
                this.filter();
                this.showFilters = false;
            } else {
                // close other filter options
                this.$root.$emit('close-filter-options');
                this.showFilters = true;
            }
        },
        setChecked() {
            const form = {};

            for (const item of this.filterData[this.dataKey]) {
                if (this.filters[this.dataKey].some(id => id == item.id)) form[item.id] = true;
                else form[item.id] = false;
            }

            this.form = form;
        },
        filter() {
            const newFilterArr = [];

            for (const itemId in this.form) {
                if (!this.form[itemId]) continue;
                newFilterArr.push(parseInt(itemId));
            }

            this.showFilters = false;

            this.$store.commit('product-list/SET_LOADING', true);

            setTimeout(() => {
                // Check if filter was changed
                if (JSON.stringify(this.filters[this.dataKey].sort()) === JSON.stringify(newFilterArr.sort())) {
                    this.$store.commit('product-list/SET_LOADING', false);
                    return;
                }

                this.$store.commit('product-filters/SET_FILTER', {
                    key: this.dataKey,
                    value: newFilterArr,
                });

                setTimeout(() => {
                    this.$root.$emit('filterChanged');
                }, 10);
            }, 10);
        },
        closeWindow() {
            if (this.showFilters == true) {
                this.filter();
                this.showFilters = false;
            }
        },
    },
};
</script>

<style lang="scss" scoped></style>
